import React from "react";
import { Users03 } from "@untitled-ui/icons-react";
import BuildingIcon from "../../shared/Icons/BuildingIcon";
import UsersIcon from "../../shared/Icons/UsersIcon";
import SpeakerIcon from "../../shared/Icons/SpeakerIcon";
import IntegrationsIcon from "../../shared/Icons/IntegrationsIcon";
import CreditCardIcon from "../../shared/Icons/CreditCardIcon";
import TicketSettingsIcon from "../../shared/Icons/TicketSettingsIcon";
import CalendarIcon from "../../shared/Icons/CalendarIcon";
import CalendarCheckSettingsIcon from "../../shared/Icons/CalendarCheckSettingsIcon";
import DocumentIcon from "../../shared/Icons/DocumentIcon";
import BankIcon from "../../shared/Icons/BankIcon";
import MembershipIcon from "../../shared/Icons/MembershipIcon";
import AssetsIcon from "../../shared/Icons/AssetsIcon";
import TagIcon from "../../shared/Icons/TagIcon";
import CurrencyDollarCircleIcon from "../../shared/Icons/CurrencyDollarCircleIcon";
import SeriesNavIcon from "../../shared/Icons/SeriesNavIcon";
import GiftIcon from "../../shared/Icons/GiftIcon";

const SeriesSettingsIcon = () => <SeriesNavIcon className="" size={24} style={{ marginTop: 0 }} />;

const CrmSettingsIcon = () => <Users03 width={24} height={24} />;

const SETTINGS_ITEMS = [
  {
    title: "Account",
    description: "Company info, legal details, and payment methods.",
    iconComponent: BuildingIcon,
    path: (teamId) => `/teams/${teamId}/account_details`,
  },
  {
    title: "Team",
    description: "Members, roles, and pending invitations.",
    iconComponent: UsersIcon,
    path: (teamId) => `/teams/${teamId}/team_details`,
  },
  {
    title: "Venues",
    description: "Venue addresses, timezones, and details.",
    iconComponent: SpeakerIcon,
    path: (teamId) => `/teams/${teamId}/venue_details`,
  },
  {
    title: "Integrations",
    description: "Manage integrations with other services you use.",
    iconComponent: IntegrationsIcon,
    path: (teamId) => `/teams/${teamId}/integration_details`,
  },
  {
    title: "Billing & Payments",
    description: "Invoices, payment processing, and payout settings.",
    iconComponent: CreditCardIcon,
    path: (teamId) => `/teams/${teamId}/billing_details`,
  },
  {
    title: "Ticketing",
    description: "Fees, statement descriptors, and seating configuration.",
    iconComponent: TicketSettingsIcon,
    path: (teamId) => `/teams/${teamId}/ticketing_settings`,
  },
  {
    title: "Events",
    description: "Templates, show activities, and promoter visibility.",
    iconComponent: CalendarIcon,
    path: (teamId) => `/teams/${teamId}/events_details`,
  },
  {
    title: "Series",
    description: "How dates read on your public series pages.",
    iconComponent: SeriesSettingsIcon,
    path: (teamId) => `/teams/${teamId}/series_details`,
  },
  {
    title: "Holds",
    description: "Default hold duration and expiration rules.",
    iconComponent: CalendarCheckSettingsIcon,
    path: (teamId) => `/teams/${teamId}/holds_details`,
  },
  {
    title: "Offers",
    description: "Offer defaults, signature lines, and settlement options.",
    iconComponent: DocumentIcon,
    path: (teamId) => `/teams/${teamId}/offers_details`,
  },
  {
    title: "Memberships",
    description: "Membership products, pricing, and venue access.",
    iconComponent: MembershipIcon,
    path: (teamId) => `/teams/${teamId}/membership_products`,
  },
  {
    title: "Currency",
    description: "Primary and secondary currency preferences.",
    iconComponent: BankIcon,
    path: (teamId) => `/teams/${teamId}/currency_details`,
  },
  {
    title: "P&L",
    description: "Automated Show Profitability Report emails and recipients.",
    iconComponent: CurrencyDollarCircleIcon,
    path: (teamId) => `/teams/${teamId}/profit_and_loss_settings`,
  },
  {
    title: "Gift cards",
    description: "Default terms and fees for gift cards.",
    iconComponent: GiftIcon,
    path: (teamId) => `/teams/${teamId}/gift_card_settings`,
    visible: ({ canAccessGiftCards }) => Boolean(canAccessGiftCards),
  },
  {
    title: "CRM",
    description: "Contact labels, tags, custom fields, and objects.",
    iconComponent: CrmSettingsIcon,
    path: (teamId) => `/teams/${teamId}/crm-settings`,
    visible: ({ canAccessCrm }) => Boolean(canAccessCrm),
  },
  {
    title: "Assets",
    description: "Default folders for event assets.",
    iconComponent: AssetsIcon,
    path: (teamId) => `/teams/${teamId}/assets_details`,
  },
  {
    title: "Tags",
    description: "Rename, merge, and delete tags across your team.",
    iconComponent: TagIcon,
    path: (teamId) => `/teams/${teamId}/tags_details`,
  },
];

const SettingsItem = ({ title, description, iconComponent: IconComponent, href }) => (
  <a href={href} className="d-flex align-items-center py-3 text-decoration-none settings-list-item">
    <div className="d-flex align-items-center justify-content-center mr-3 settings-list-item__icon">
      {IconComponent && <IconComponent />}
    </div>
    <div>
      <div className="font-weight-bold">{title}</div>
      <div className="small settings-list-item__description">{description}</div>
    </div>
  </a>
);

const Settings = ({ teamId, ...flags }) => (
  <div className="mt-3">
    <h3 className="mb-1">Settings</h3>
    <p className="mb-4 settings-subtitle">Manage your account settings and preferences.</p>
    <div className="card settings-card">
      <div className="card-body p-0">
        {SETTINGS_ITEMS.filter((item) => !item.visible || item.visible(flags)).map((item) => (
          <SettingsItem
            key={item.title}
            title={item.title}
            description={item.description}
            iconComponent={item.iconComponent}
            href={item.path ? item.path(teamId) : null}
          />
        ))}
      </div>
    </div>
  </div>
);

export default Settings;
